import { queryOptions } from '@tanstack/react-query';
import { getConfigQuery } from './get-config-query';

export const getConfigQueryOptions = (healthCenterId?: string) =>
  queryOptions({
    queryKey: ['get-config', healthCenterId],
    queryFn: () => getConfigQuery(healthCenterId!),
    enabled: !!healthCenterId,
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
    refetchInterval: 60 * 1000,
  });
